import { render, staticRenderFns } from "./seller_login.vue?vue&type=template&id=04ae8c8d&scoped=true"
import script from "./seller_login.vue?vue&type=script&lang=js"
export * from "./seller_login.vue?vue&type=script&lang=js"
import style0 from "./seller_login.vue?vue&type=style&index=0&id=04ae8c8d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ae8c8d",
  null
  
)

export default component.exports